import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ToolsService} from 'src/app/services/tools.service';

@Component({
  selector: 'app-line-rating',
  templateUrl: './line-rating.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LineRatingComponent {
  label = input<string>('Snittbetyg');
  rate = input<number>(null);
  barWidthPercentage = computed<number>(() => Math.round(this.rate() * 20));
  private tools: ToolsService = inject(ToolsService);
  rateToDisplay = computed<number>(() => this.tools.round(this.rate(), 2));
}
